import { toJS } from 'mobx'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import { extendRules, getSingleRule, initFilter } from 'src/utils/common'
import { guid } from 'src/utils/tools'

export default {
  onTypeChange (EditContext: any, FIELD_NAME: string, data: any) {
    const copyDataSource = toJS(EditContext.editPageTable.activeTableData?.dataSource || [])
    copyDataSource.forEach((item: any) => item.IS_DELETED = true)

    if (data.value) {
      const payload = initFilter({
        OrgId: mainStore.headers.OrgId,
        Limit: 1000
      })
      extendRules(payload, [getSingleRule('EQUIPMENT_TYPE_ID', 1, data.value)])
      $api['app/getDataByPost'](payload, {
        url: '/OP/EquipmentTypeAttr/Entities'
      }).then(res => {
        res && EditContext.editPageTable.activeTable.setDataSource(res.map((item: any) => ({
          ...item,
          Nav_EquipmentTypeAttr: {
            ID: item.ID,
            CODE: item.CODE,
            NAME: item.NAME
          },
          ID: guid(),
          EQUIPMENT_TYPE_ATTR_ID: item.ID,
          EQUIPMENT_MODEL_ID: EditContext.formBase.ID
        })).concat(copyDataSource))
      })
    } else {
      EditContext.editPageTable.activeTable.setDataSource(copyDataSource)
    }
  },
  attrNameChange (EditContext: any, FIELD_NAME: string, data: any) {
    const { activeTable, activeTableData } = EditContext.editPageTable
    const copyDataSource = toJS(activeTableData.dataSource)
    const copyRecord = copyDataSource.find((item: any) => item.ID === data.config.__RECORD__.ID)
    const selected = data.payload.find((item: any) => item.ID === data.value)
    Object.assign(copyRecord, { 'Nav_EquipmentTypeAttr.CODE': selected.CODE })
    activeTable.setDataSource(copyDataSource)
  },
  dltAttrNameChange (EditContext: any, FIELD_NAME: string, data: any) {
    const { activeTable, activeTableData } = EditContext.editPageTable
    const copyDataSource = toJS(activeTableData.dataSource)
    const copyRecord = copyDataSource.find((item: any) => item.ID === data.config.__RECORD__.ID)
    const selected = data.payload.find((item: any) => item.ID === data.value)
    Object.assign(copyRecord, { 'Nav_EquipmentTypeAttr.CODE': selected.CODE })

    $api['app/getDataByGet'](
      { name: selected.NAME },
      { url: '/OP/OPEquipmentType/GetAddressNum', noAttachedData: true }
    ).then(res => {
      res && Object.assign(copyRecord, { POINT_NAME: res })
    }).finally(() => {
      activeTable.setDataSource(copyDataSource)
    })
  },
}